<script>
  export let id

  import { fetchO, patchO, postO } from '../../oauth.js'
  import WorkoutTrainingWidget from '../../components/WorkoutTrainingWidget.svelte'
  import WorkoutChooser from '../../components/WorkoutChooser.svelte'

  function now() {
    return new Date().toISOString()
  }

  async function startWorkout() {
    const response = await postO('/workouts/', {
      workout_plan: workoutPlan['url'],
      start: now(),
    })
    if (response.status == 201) {
      const w = await response.json()

      // Fetch Details
      const responseDetail = await fetchO(w.url + 'details/')
      return await responseDetail.json()
    }
  }

  async function finishWorkout() {
    await patchO(workout.url, {
      finish: now(),
    })
  }

  async function startExercise(e) {
    console.log('startExercise Event', e)
    await patchO(e.detail.exercise.url, { start: now() })
  }

  async function finishExercise(e) {
    console.log('finishExercise Event', e)
    await patchO(e.detail.exercise.url, {
      finish: now(),
      result_type: 'complete',
      actual_amount: e.detail.planExercise.amount,
    })
  }

  async function startSet(e) {
    console.log('startSet Event', e)
    await patchO(e.detail.set.url, { start: now() })
  }

  async function finishSet(e) {
    console.log('finishSet Event', e)
    await patchO(e.detail.set.url, { finish: now() })
  }

  let workoutPlan
  let error
  let workout
  let workouts
  ;(async () => {
    let response = await fetchO('/workout_plans/' + id + '/details/')
    if (response.status == 200) {
      workoutPlan = await response.json()

      // Check if there is a workout to finish
      response = await fetchO(
        '/workouts/?no_finish=True&workout_plan=' +
          workoutPlan['id'] +
          '&start_after=2021-12-25'
      )
      const workouts_response = await response.json()

      if (workouts_response['count'] == 0) {
        // No workout to finish, start a new one directly
        workout = await startWorkout()
      } else {
        workouts = workouts_response['results']
      }
    } else {
      error = 'Workout Plan not found'
    }
  })()

  async function resumeWorkout(choosenWorkout) {
    // Fetch the details of the workout
    const response = await fetchO(choosenWorkout['url'] + 'details/')
    workout = await response.json()
    console.log('Workout now', workout)
  }
</script>

{#if error}
  <div class="alert alert-danger" role="alert">
    {error}
  </div>
{:else if !workoutPlan || (!workout && !workouts)}
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
{:else if workout}
  <h1>{workoutPlan.title}</h1>
  <WorkoutTrainingWidget
    {workoutPlan}
    {workout}
    on:finishWorkout={finishWorkout}
    on:startExercise={startExercise}
    on:finishExercise={finishExercise}
    on:startSet={startSet}
    on:finishSet={finishSet}
  />
{:else if workouts}
  <h1>{workoutPlan.title}</h1>
  <i>There is an unfinished Workout, would you like to resume them?</i>
  <WorkoutChooser
    {workouts}
    on:chooseWorkout={(e) => {
      resumeWorkout(e.detail)
    }}
    on:startNewWorkout={async () => {
      workout = await startWorkout()
    }}
  />
{/if}

<svelte:head>
  {#if workoutPlan}
    <title>Training Fich Workout Plan {workoutPlan.title}</title>
  {/if}
</svelte:head>
